import React, { useState } from 'react'
import './InsurancePlansSolutions.component.scss'

const ChevronDown = () => (
  <svg viewBox='0 0 1152 1792' fill='currentColor'>
    <path d='M1075 736q0 13-10 23l-466 466q-10 10-23 10t-23-10L87 759q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z' />
  </svg>
)

const InsurancePlansSolutions = ({ heading, body, contentType, items, image }) => {
  const [openIndex, setOpenIndex] = useState(-1)

  const handleToggle = index => {
    setOpenIndex(openIndex === index ? -1 : index)
  }

  return (
    <section className='insurance-plans-solutions'>
      <div className='insurance-plans-solutions__grid'>
        <div
          className={`insurance-plans-solutions__outer${
            contentType === 'list' && image ? ' insurance-plans-solutions__outer--with-image' : ''
          }`}
        >
          <div className='insurance-plans-solutions__left'>
            <h2 className='insurance-plans-solutions__heading'>{heading}</h2>
            {body && <p className='insurance-plans-solutions__body'>{body}</p>}
            {contentType === 'list' && (
              <ul className='insurance-plans-solutions__list'>
                {items.map((item, index) => (
                  <li key={index} className='insurance-plans-solutions__list-item'>
                    {item.title}
                  </li>
                ))}
              </ul>
            )}
          </div>
          {contentType === 'list' && image && (
            <div className='insurance-plans-solutions__right'>
              <div className='insurance-plans-solutions__image-wrapper'>
                <img className='insurance-plans-solutions__image' src={image.src} alt={image.alt || ''} />
              </div>
            </div>
          )}
          {contentType === 'accordion' && (
            <div className='insurance-plans-solutions__right'>
              <ul className='insurance-plans-solutions__accordion'>
                {items.map((item, index) => (
                  <li
                    key={index}
                    className='insurance-plans-solutions__accordion-item'
                    onClick={() => handleToggle(index)}
                  >
                    <div className='insurance-plans-solutions__accordion-title-wrapper'>
                      <h3 className='insurance-plans-solutions__accordion-title'>
                        <span>{item.title}</span>
                      </h3>
                      <div
                        className={`insurance-plans-solutions__accordion-arrow ${
                          openIndex === index ? 'insurance-plans-solutions__accordion-arrow--open' : ''
                        }`}
                      >
                        <ChevronDown />
                      </div>
                    </div>
                    <div
                      className={`insurance-plans-solutions__accordion-collapse ${
                        openIndex === index ? 'insurance-plans-solutions__accordion-collapse--open' : ''
                      }`}
                    >
                      <div className='insurance-plans-solutions__accordion-content'>
                        <div className='insurance-plans-solutions__accordion-description'>
                          <p>{item.description}</p>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default InsurancePlansSolutions
